import React from 'react';
import Icon from './Icon';

export default Icon(
  <path d="M4.1,11.7c0.1-0.1,0.3-0.3,0.3-0.3s0.7-0.8,1.1-1.1c0.3-0.2,0.5-0.2,0.8,0c1,1,2.2,2,3.2,3
	c0.3, 0.3, 0.6, 0.3, 0.9, 0c2.4-2.2, 4.8-4.4, 7.2-6.6c0.3-0.3, 0.6-0.3, 0.9, 0c0.4, 0.4, 0.8, 0.8, 1.3, 1.2c0.3, 0.2, 0.3, 0.5, 0, 0.7
	c-3.1, 2.9-6.3, 5.7-9.4, 8.6c-0.3, 0.2-0.5, 0.2-0.8, 0c-1.8-1.7-3.5-3.3-5.3-5C4.1, 12.1, 4, 11.9, 4.1, 11.7z"
  />, '0 0 24 24', 'SuccessoIcon',
);
